import { render } from "./PrintHoldingsModule.vue?vue&type=template&id=2d9601bf&scoped=true"
import script from "./PrintHoldingsModule.vue?vue&type=script&lang=js"
export * from "./PrintHoldingsModule.vue?vue&type=script&lang=js"

import "./PrintHoldingsModule.vue?vue&type=style&index=0&id=2d9601bf&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2d9601bf"

export default script